import Component from "./teams";

import {bindActionCreators} from "redux";
import {getTeams, createNewTeam} from '../../store/actions/teams';
import connect from "react-redux/es/connect/connect";



function mapStateToProps(state) {
    const teams = state.teams;

    return {
        teams
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({getTeams, createNewTeam}, dispatch);
}

export const Teams = connect(mapStateToProps, mapDispatchToProps)(Component);